(function () {
  console.log('RI: custom form script loaded');

  const HUBSPOT_PORTAL_ID = '146895443';
  const HUBSPOT_FORM_ID = '103e0401-2af5-407b-bb50-abb06ec6562f';
  const HUBSPOT_SUBMIT_URL =
    'https://api.hsforms.com/submissions/v3/integration/submit/' +
    HUBSPOT_PORTAL_ID +
    '/' +
    HUBSPOT_FORM_ID;

  let currentRiData = null;
  let isSubmitting = false;

  function getEl(id) {
    return document.getElementById(id);
  }

  function getCookie(name) {
    const match = document.cookie.match(
      new RegExp('(^| )' + name + '=([^;]+)')
    );
    return match ? decodeURIComponent(match[2]) : '';
  }

  function openModal(data) {
    const modal = getEl('RegisterInterestModal');
    if (!modal) return;

    currentRiData = data || {};

    fillHiddenFields(currentRiData);

    const contextText = getEl('ri-modal-context-text');
    if (contextText) {
      contextText.textContent = currentRiData.interest_item_name
        ? 'Sign up to hear first about ' + currentRiData.interest_item_name + '.'
        : 'Sign up to hear first about this artwork.';
    }

    hideMessages();

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ri-modal-open');

    const firstInput = getEl('ri-firstname');
    if (firstInput) firstInput.focus();

    console.log('RI: modal opened', currentRiData);
  }

  function closeModal() {
    const modal = getEl('RegisterInterestModal');
    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ri-modal-open');

    console.log('RI: modal closed');
  }

  function fillHiddenFields(data) {
    setValue('ri-interest-item-id', data.interest_item_id || '');
    setValue('ri-interest-cta-label', data.interest_cta_label || 'Register interest');
    setValue('ri-interest-item-name', data.interest_item_name || '');
    setValue('ri-interested-artists', data.artwork_interest || '');
    setValue('ri-interest-type', data.interest_type || 'product');
    setValue('ri-interest-source-url', data.interest_source_url || window.location.href);

    console.log('RI: hidden fields filled', {
      interest_item_id: getValue('ri-interest-item-id'),
      interest_cta_label: getValue('ri-interest-cta-label'),
      interest_item_name: getValue('ri-interest-item-name'),
      interested_artists: getValue('ri-interested-artists'),
      interest_type: getValue('ri-interest-type'),
      interest_source_url: getValue('ri-interest-source-url')
    });
  }

  function setValue(id, value) {
    const el = getEl(id);
    if (el) el.value = value;
  }

  function getValue(id) {
    const el = getEl(id);
    return el ? el.value : '';
  }

  function hideMessages() {
    const errorBox = getEl('ri-form-error');
    const successBox = getEl('ri-form-success');

    if (errorBox) {
      errorBox.hidden = true;
      errorBox.textContent = '';
    }

    if (successBox) {
      successBox.hidden = true;
    }
  }

  function showError(message) {
    const errorBox = getEl('ri-form-error');
    if (!errorBox) return;

    errorBox.textContent = message;
    errorBox.hidden = false;
  }

  function showSuccess() {
    const successBox = getEl('ri-form-success');
    if (!successBox) return;

    successBox.hidden = false;
  }

  function validateForm(form) {
    const firstname = form.querySelector('[name="firstname"]');
    const lastname = form.querySelector('[name="lastname"]');
    const email = form.querySelector('[name="email"]');
    const acceptanceCheck = form.querySelector('[name="acceptance_check"]');
    const phone = form.querySelector('[name="phone"]');

    if (!firstname || !firstname.value.trim()) {
      return 'First name is required.';
    }

    if (!lastname || !lastname.value.trim()) {
      return 'Last name is required.';
    }

    if (!email || !email.value.trim()) {
      return 'Email is required.';
    }

    if (!phone || !phone.value.trim()) {
      return 'Phone number is required.';
    }

    const phoneValue = phone.value.trim();
    const phoneDigits = phoneValue.replace(/\D/g, '');

    if (phoneDigits.length < 10 || phoneDigits.length > 15) {
      return 'Please enter a valid phone number.';
    }

    const emailValue = email.value.trim();
    const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue);
    if (!emailOk) {
      return 'Please enter a valid email address.';
    }

    if (!acceptanceCheck || !acceptanceCheck.checked) {
      return 'Please confirm before submitting.';
    }

    return '';
  }

  function buildPayload(form) {
    const fields = [
      { name: 'firstname', value: form.querySelector('[name="firstname"]').value.trim() },
      { name: 'lastname', value: form.querySelector('[name="lastname"]').value.trim() },
      { name: 'email', value: form.querySelector('[name="email"]').value.trim() },
      { name: 'acceptance_check', value: form.querySelector('[name="acceptance_check"]').checked ? 'true' : 'false' },
      { name: 'interest_item_id', value: form.querySelector('[name="interest_item_id"]').value },
      { name: 'interest_cta_label', value: form.querySelector('[name="interest_cta_label"]').value },
      { name: 'interest_item_name', value: form.querySelector('[name="interest_item_name"]').value },
      { name: 'interested_artists', value: form.querySelector('[name="interested_artists"]').value },
      { name: 'interest_type', value: form.querySelector('[name="interest_type"]').value },
      { name: 'interest_source_url', value: form.querySelector('[name="interest_source_url"]').value }
    ];

    const phoneEl = form.querySelector('[name="phone"]');
    if (phoneEl && phoneEl.value.trim()) {
      fields.push({
        name: 'phone',
        value: form.querySelector('[name="phone"]').value.trim()
      });
    }

    const hutkValue = getCookie('hubspotutk');

    return {
      submittedAt: Date.now(),
      fields: fields,
      context: Object.assign(
        {
          pageUri: getValue('ri-interest-source-url') || window.location.href,
          pageName: document.title
        },
        hutkValue ? { hutk: hutkValue } : {}
      ),
      legalConsentOptions: {
        consent: {
          consentToProcess: true,
          text: 'I agree to allow Creed Gallery to store and process my personal data.'
        }
      }
    };
  }

  async function submitToHubSpot(form) {
    const payload = buildPayload(form);

    console.log('RI: submitting payload', payload);

    const response = await fetch(HUBSPOT_SUBMIT_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    let data = null;
    try {
      data = await response.json();
    } catch (e) {
      data = null;
    }

    if (!response.ok) {
      console.log('RI: submit failed', response.status, data);

      let detailedMessage = 'Unable to submit the form right now. Please try again.';

      if (data) {
        if (Array.isArray(data.errors) && data.errors.length) {
          detailedMessage = data.errors.map(function (err) {
            return err.message || JSON.stringify(err);
          }).join(' | ');
        } else if (data.message) {
          detailedMessage = data.message;
        }
      }

      throw new Error(detailedMessage);
    }

    console.log('RI: submit success', data);
    return data;
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (isSubmitting) return;

    const form = e.currentTarget;
    hideMessages();

    const validationMessage = validateForm(form);
    if (validationMessage) {
      showError(validationMessage);
      return;
    }

    const submitBtn = getEl('ri-form-submit');
    const originalText = submitBtn ? submitBtn.textContent : '';

    try {
      isSubmitting = true;
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting...';
      }

      await submitToHubSpot(form);

      form.reset();

      if (currentRiData) {
        fillHiddenFields(currentRiData);
      }

      showSuccess();

      setTimeout(function () {
        closeModal();
      }, 1800);
    } catch (error) {
      showError(error.message || 'Something went wrong. Please try again.');
    } finally {
      isSubmitting = false;
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = originalText || 'Register interest';
      }
    }
  }

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-register-interest-trigger]');
    if (trigger) {
      e.preventDefault();

      const data = {
        artwork_interest: trigger.dataset.contextName || '',
        interest_type: trigger.dataset.contextType || 'product',
        interest_item_id: trigger.dataset.contextId || '',
        interest_item_name: trigger.dataset.contextName || '',
        interest_cta_label: trigger.dataset.ctaLabel || 'Register interest',
        interest_source_url: trigger.dataset.sourceUrl || window.location.href
      };

      console.log('RI CLICKED');
      console.log('RI DATA:', data);

      openModal(data);
      return;
    }

    const closeBtn = e.target.closest('[data-ri-close]');
    if (closeBtn) {
      e.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeModal();
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    const form = getEl('ri-custom-form');
    if (form) {
      form.addEventListener('submit', handleSubmit);
    }
  });
})();